import { any } from "prop-types";
import * as React from "react"
import { useEffect, useState } from "react";

interface IProps{
  eventDate:string
}

function Countdown(props: IProps){

  const [isLive, setIsLive] = useState(false)
  const [timeLeft, setTimeLeft] = useState({days:null, hours:null, minutes:null, seconds:null});

  const calculateTimeLeft = () => {
    const difference = +new Date(props.eventDate) - +new Date();
    let timeLeft:any = {};
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }
    else {
      setIsLive(true)
    }
    return timeLeft
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  });

  return (
    <>
    { !isLive && timeLeft.days && (
      <>
        <h1 style={{color:'white'}}>Time Left Until Next Academy...</h1>
        <h1 className="countdown-text">
          { timeLeft.days} :
          { timeLeft.hours} :
          { timeLeft.minutes} :
          { timeLeft.seconds}
        </h1>  
      </>
    )}
    {isLive && (
      <>
        <h1 className="countdown-text">
          Academy is Live!
          <div className="blobs-container">
            <div className="blob red" style={{width:'20px', height:'20px'}}></div>
          </div>
        </h1>  
        <a className="btn btn-light" target="_blank" rel="noopener noreferrer" href="https://chartec.net/msp-training-session/">View Agenda</a>
      </>
    )}
    </>
    
  )
}

export default Countdown


// WEBPACK FOOTER //
// ./app/javascript/components/pages/Countdown.tsx